import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface BudgetViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class BudgetViewPage extends Component<BudgetViewPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.budget.view }}
                pages={{
                    entity: InferenceEntities.budget(this.props),
                    view: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}